import { createStore } from 'vuex'
import axios from 'axios'
import router from '../router'

export default createStore({
  state: {
    // Project URLs, if you are in developer, select the value of .env otherwise use the current URL
    api: process.env.NODE_ENV !== 'development' ? window.location.origin + process.env.VUE_APP_DIRECTORY + '/backstage/api' : process.env.VUE_APP_API_URL + '/backstage/api',
    files: process.env.NODE_ENV !== 'development' ? window.location.origin + process.env.VUE_APP_DIRECTORY + '/files/' : process.env.VUE_APP_API_URL + '/files/',
    front: process.env.NODE_ENV !== 'development' ? window.location.origin + process.env.VUE_APP_DIRECTORY : process.env.VUE_APP_API_URL,
    pay: 'https://www.bressolcreatiu.com/' + process.env.VUE_APP_DIRECTORY_PAY + '/index.php',

    selectedTool: null,
    confirm: {},

    translations: {},

    languageSelected: localStorage.getItem('language') ? localStorage.getItem('language') : 'ca',
    languages: [],
    categories: [],
    ods: [],
    accessibility: [],
    user: {},

    logged: false,
    editor: false,
    editor_activity: null,
    usertype: null,

    errors: {
      login: [],
      regist: [],
      event: [],
      user: [],
      activity: [],
      program: [],
      equipment: [],
      budget: [],
      pay: [],
      email: []
    },
    info: {
      login: []
    },
    memoryevents: [],
    events: [],
    event: {},
    eventLanguages: [],
    eventDays: {},

    activities: [],
    activity: {},
    activityID: null,
    activity_finished: false,
    budget: [],

    programs: [],
    programID: null,
    program: {},

    equipments: [],
    equipmentID: null,
    equipment: {},

    editoractivities: [],
  },
  mutations: {
    setTranslations(state, value) {
      state.translations = value
    },
    setUser(state, value) {
      state.user = value
    },
    changeToolSelected(state, value) {
      state.selectedTool = value

    },
    setLanguage(state, value) {
      state.languageSelected = value
    },
    setExtraFields(state, value) {
      state.languages = value.languages
      state.categories = value.categories
      state.ods = value.ods
      state.accessibility = value.accessibility
    },
    setEditor(state, value) {
      state.editor = value
    },
    setUsertype(state, value) {
      state.usertype = value
    },
    setEvents(state, value) {
      state.events = value
    }, setMemoryEvents(state, value) {
      state.memoryevents = value
    },
    setEvent(state, value) {
      state.event = value
    },
    setActivities(state, value) {
      state.activities = value
    },
    setPrograms(state, value) {
      state.programs = value
    },
    setEquipments(state, value) {
      state.equipments = value
    },

    setEditorActivities(state, value) {
      state.editoractivities = value
    },
    saveActivityID(state, value) {
      state.activityID = value.id
      state.editor_activity = value.type
    },
    saveProgramID(state, value) {
      state.programID = value
    },
    saveEquipmentID(state, value) {
      state.equipmentID = value
    },
    setActivity(state, value) {
      state.activity = value
    },
    setActivityFinished(state, value) {
      state.activity_finished = value
    },

    setBudget(state, value) {
      state.budget = value
    },
    setProgram(state, value) {
      state.program = value
    }, setEquipment(state, value) {
      state.equipment = value
    },
    changeLoggedStatus(state, value) {
      state.logged = value

    },
    resetError(state, value) {
      state.errors = {
        login: [],
        regist: [],
        event: [],
        user: [],
        activity: [],
        program: [],
        equipment: [],
        budget: [],
        pay: [],
        email: []
      }
      state.info = {
        login: []
      }
    },
    setError(state, value) {

      if (!value.text) {
        value.text = translations.api.unexpected_error
      }
      if (typeof value.text == "object") {
        value.text.forEach(element => {
          state.errors[value.type].push(element.text)
        });
      } else {
        state.errors[value.type].push(value.text)
      }
    },
    setInfo(state, value) {
      switch (value.type) {
        case "login":
          state.info.login.push(value.text)

          break;
      }
    },
    setEventLanguages(state, value) {
      state.eventLanguages = value
    },
    setEventDays(state, value) {
      state.eventDays = value
    },
    saveConfirm(state, value) {
      state.confirm = value
    }
  },
  actions: {

    async selectLanguage({ commit, state }, id) {
      let ls = JSON.parse(localStorage.getItem('token'))
      if (ls) {
        let value = { token: ls.token, lang: id }
        let result = await axios({
          method: 'post',
          data: value,
          url: `${state.api}/changeLanguage`,
          transformRequest: function (obj) {
            var str = [];
            for (var p in obj)
              str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            return str.join("&");
          },
          headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
        })
      }
      commit('setLanguage', id)
      localStorage.setItem('language', id)

    },
    setError({ commit, state }, value) {
      const error = state.translations.api[value.text] || value.text
      commit('setError', { type: value.type, text: error })
    },

    // function get all translations for the project
    async getTranslations({ commit, state }) {
      if (!['ca', 'es'].includes(state.languageSelected)) {
        await this.dispatch('selectLanguage', 'ca')

      }
      let value = { language: state.languageSelected.toUpperCase() }
      let result = await axios({
        method: 'post',
        url: `${state.api}/translations`,
        data: value,
        transformRequest: function (obj) {
          var str = [];
          for (var p in obj)
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
          return str.join("&");
        },
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
      })

      let obj = await result.data;
      if (obj.status) {
        await commit('setTranslations', obj.data)

      }
    },

    /**
     * 10 -> Activity Add
     * 11 -> Activity Edit
     * 13 -> Edit event
     * 14 -> Terms use
     * 15 -> Share Event
     * 16 -> Program Add
     * 17 -> Program Edit
     * 20 -> Activity Budget
     */
    changeToolSelected({ commit, state }, value) {
      commit('changeToolSelected', value)
    },

    resetError({ commit, state }) {
      commit('resetError')

    },

    async regist({ commit, state }, value) {
      commit('resetError')
      if (value) {

        let result = await axios({
          method: 'post',
          url: `${state.api}/regist`,
          data: value,
          transformRequest: function (obj) {
            var str = [];
            for (var p in obj)
              str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            return str.join("&");
          },
          headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
        })
        let obj = await result.data;
        if (obj.status) {

          let data = {
            email: obj.data.email,
            password: obj.data.password,

          }
          await this.dispatch('login', data)

        } else {
          commit('setError', { type: 'regist', text: obj.data })
        }
      }
    },

    async login({ commit, state }, value) {
      this.dispatch('resetError')

      if (value) {
        let result = await axios({
          method: 'post',
          url: `${state.api}/login`,
          data: value,
          transformRequest: function (obj) {
            var str = [];
            for (var p in obj)
              str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            return str.join("&");
          },
          headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
        })

        let obj = await result.data;

        if (obj.status) {

          commit('changeLoggedStatus', true);
          localStorage.setItem('token', JSON.stringify(obj.data))
          commit('setEditor', obj.data.editor);
          commit('setUsertype', obj.data.type);

          router.push('/events')


        } else {

          commit('changeLoggedStatus', false);
          commit('setError', { type: 'login', text: obj.data })
        }

      }
    },

    async recoverPassword({ commit, state }, value) {
      this.dispatch('resetError')

      if (value) {
        let message = { email: value, lang: state.languageSelected.toUpperCase() }
        let result = await axios({
          method: 'post',
          url: `${state.api}/recoverPassword`,
          data: message,
          transformRequest: function (obj) {
            var str = [];
            for (var p in obj)
              str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            return str.join("&");
          },
          headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
        })
        let obj = await result.data;

        if (obj.status) {
          commit('setInfo', { type: 'login', text: obj.data });

        } else {
          commit('setError', { type: 'login', text: obj.data });
        }
      }

    },
    async changePassword({ commit, state }, value) {
      if (value) {
        let result = await axios({
          method: 'post',
          url: `${state.api}/changePassword`,
          data: value,
          transformRequest: function (obj) {
            var str = [];
            for (var p in obj)
              str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            return str.join("&");
          },
          headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
        })
        let obj = await result.data;
        if (obj.status) {
          router.push('/')
          this.dispatch('login', { action: 'login', email: obj.data.email, password: value.password })

        }
      }

    },

    async logout({ commit, state }) {

      let ls = JSON.parse(localStorage.getItem('token'))
      if (ls) {
        let value = { token: ls.token }
        let result = await axios({
          method: 'post',
          data: value,
          url: `${state.api}/deleteToken`,
          transformRequest: function (obj) {
            var str = [];
            for (var p in obj)
              str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            return str.join("&");
          },
          headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
        })
        let obj = await result.data;
        if (obj.status) {
          commit('changeLoggedStatus', false);
          router.push('/login')
          localStorage.removeItem('token');

        }
      }

    },

    // function to get the necessary information to work with the localstorage
    async getToken({ commit, state }) {
      let ls = JSON.parse(localStorage.getItem('token'))
      if (ls) {
        let value = { token: ls.token }
        let result = await axios({
          method: 'post',
          data: value,
          url: `${state.api}/getToken`,
          transformRequest: function (obj) {
            var str = [];
            for (var p in obj)
              str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            return str.join("&");
          },
          headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
        })
        let obj = await result.data;
        if (obj.status) {
          commit('changeLoggedStatus', true);
          let ls = JSON.parse(localStorage.getItem('token'))
          ls.type = obj.data.type
          ls.plan_expiration = obj.data.plan_expiration
          ls.editor = obj.data.editor
          ls.lang = obj.data.lang
          localStorage.setItem('token', JSON.stringify(ls))

          commit('setEditor', obj.data.editor);
          commit('setUsertype', obj.data.type);


        } else {
          commit('changeLoggedStatus', false);
          router.push('/login')
          localStorage.removeItem('token');

        }
      }

    },
    async saveConfirm({ commit, state }, value) {
      commit('saveConfirm', value)

    },

    async confirmDelete({ commit, state }) {
      if (state.confirm) {
        let ls = JSON.parse(localStorage.getItem('token'))

        if (ls) {
          let data = {
            token: ls.token,
            id: state.confirm.id,
            type: state.confirm.type
          }

          let result = await axios({
            method: 'post',
            url: `${state.api}/confirmDelete`,
            data: data,
            transformRequest: function (obj) {
              var str = [];
              for (var p in obj)
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
              return str.join("&");
            },
            headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
          })
          let obj = await result.data;

          if (obj.status) {
            switch (state.confirm.type) {
              case 'activity':
                this.dispatch('getActivities', state.confirm.event_id)
                break;

              default:
                router.push('/')
                break;
            }

            this.dispatch('changeToolSelected', null)

          }
        } else {
          commit('changeLogged', false)
          router.push('/')
        }
      }
    },

    async confirmEnable({ commit, state }) {
      if (state.confirm) {
        let ls = JSON.parse(localStorage.getItem('token'))

        if (ls) {

          let data = {
            token: ls.token,
            id: state.confirm.data.id,
            type: state.confirm.type
          }

          let result = await axios({
            method: 'post',
            url: `${state.api}/confirmEnable`,
            data: data,
            transformRequest: function (obj) {
              var str = [];
              for (var p in obj)
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
              return str.join("&");
            },
            headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
          })
          let obj = await result.data;

          if (obj.status) {

            switch (state.confirm.type) {
              case 'event':
                this.dispatch('getEvent', { id: state.event.id, type: 'get' })
                break;
            }

            this.dispatch('changeToolSelected', null)

          }
        } else {
          commit('changeLogged', false)
          router.push('/')
        }
      }
    },

    async changeUserType({ commit, state }, value) {
      let ls = JSON.parse(localStorage.getItem('token'))
      if (ls) {
        let data = { token: ls.token, type: value }
        let result = await axios({
          method: 'post',
          data: data,
          url: `${state.api}/changeUserType`,
          transformRequest: function (obj) {
            var str = [];
            for (var p in obj)
              str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            return str.join("&");
          },
          headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
        })
        let obj = await result.data;
        if (obj.status) {
          this.dispatch('getToken')


        } else {
          commit('changeLoggedStatus', false);
          router.push('/login')
          localStorage.removeItem('token');

        }
      }

    },
    //function to get information needed for the project
    async getExtraFields({ commit, state }) {

      let result = await axios({
        method: 'post',
        url: `${state.api}/getExtraFields`,
        transformRequest: function (obj) {
          var str = [];
          for (var p in obj)
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
          return str.join("&");
        },
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
      })
      let obj = await result.data;
      if (obj.status) {
        let languages = []
        if (obj.data.languages && obj.data.languages.length > 0) {

          obj.data.languages.forEach(element => {
            languages.push({ value: element.code, text: element.full_name })
          });
        }
        let categories = []
        if (obj.data.categories && obj.data.categories.length > 0) {


          obj.data.categories.forEach(element => {

            for (const key in element) {
              if (Object.hasOwnProperty.call(element, key)) {
                if (key == state.languageSelected) {
                  categories.push({ value: element.id, text: element[key] })

                }

              }
            }
          });
        }
        let output = {
          languages: languages,
          categories: categories,
          ods: obj.data.ods,
          accessibility: obj.data.accessibility,

        }
        commit('setExtraFields', output);

      }

    },

    async getMemoryEvents({ commit, state }) {
      let ls = JSON.parse(localStorage.getItem('token'))
      if (ls) {
        let value = { token: ls.token }
        let result = await axios({
          method: 'post',
          data: value,
          url: `${state.api}/getMemoryEvents`,
          transformRequest: function (obj) {
            var str = [];
            for (var p in obj)
              str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            return str.join("&");
          },
          headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
        })
        let obj = await result.data;
        if (obj.status) {
          commit('setMemoryEvents', obj.data);

        }
      } else {
        commit('changeLoggedStatus', false);
        router.push('/login')
        localStorage.removeItem('token');

      }

    }, async getEvents({ commit, state }) {
      let ls = JSON.parse(localStorage.getItem('token'))
      if (ls) {
        let value = { token: ls.token }
        let result = await axios({
          method: 'post',
          data: value,
          url: `${state.api}/getEvents`,
          transformRequest: function (obj) {
            var str = [];
            for (var p in obj)
              str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            return str.join("&");
          },
          headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
        })
        let obj = await result.data;
        if (obj.status) {
          commit('setEvents', obj.data);

        }
      } else {
        commit('changeLoggedStatus', false);
        router.push('/login')
        localStorage.removeItem('token');


      }

    },
    async getEvent({ commit, state }, value) {
      let ls = JSON.parse(localStorage.getItem('token'))
      if (ls) {
        value.token = ls.token
        let result = await axios({
          method: 'post',
          data: value,
          url: `${state.api}/getEvent`,
          transformRequest: function (obj) {
            var str = [];
            for (var p in obj)
              str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            return str.join("&");
          },
          headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
        })
        let obj = await result.data;
        if (obj.status) {
          commit('setEvent', obj.data);

        }
      } else {
        commit('changeLoggedStatus', false);
        router.push('/login')
        localStorage.removeItem('token');

      }

    },
    async resetEvents({ commit, state }) {
      commit('setEvents', []);

    },
    async resetEvent({ commit, state }) {
      commit('setEvent', {});

    },
    async resetActivities({ commit, state }) {
      commit('setActivities', []);

    },
    async addEvent({ commit, state }, value) {
      this.dispatch('resetError')

      let ls = JSON.parse(localStorage.getItem('token'))
      if (ls) {
        value.token = ls.token

        let formData = new FormData();
        for (var key in value) {
          if (key == 'pictures') {
            if (value.pictures && value.pictures.length > 0) {
              for (var i = 0; i < value.pictures.length; i++) {
                formData.append('pictures[' + i + ']', value.pictures[i]);
              }
            } else {
              formData.append('pictures[0]', value.pictures);
            }
          } else {
            formData.append(key, value[key]);
          }
        }
        let result = await axios({
          method: 'post',
          data: formData,
          url: `${state.api}/addEvent`,
          headers: { 'Content-Type': 'multipart/form-data' }

        })
        let obj = await result.data;
        if (obj.status) {
          router.push('/events')

        } else {
          commit('setError', { type: 'event', text: obj.data })


        }
      } else {
        commit('changeLoggedStatus', false);
        router.push('/login')
        localStorage.removeItem('token');
      }
    },
    async editEvent({ commit, state }, value) {
      this.dispatch('resetError')
      let ls = JSON.parse(localStorage.getItem('token'))
      if (ls) {
        value.token = ls.token
        let formData = new FormData();
        for (var key in value) {
          if (key == 'pictures') {
            if (value.pictures.length > 0) {
              for (var i = 0; i < value.pictures.length; i++) {
                formData.append('pictures[' + i + ']', value.pictures[i]);
              }
            } else {
              formData.append('pictures[0]', value.pictures);
            }
          } else {
            formData.append(key, value[key]);
          }
        }
        let result = await axios({
          method: 'post',
          data: formData,
          url: `${state.api}/editEvent`,
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        let obj = await result.data;
        if (obj.status) {
          this.dispatch('changeToolSelected', null)
          router.push('/events')


        } else {
          commit('setError', { type: 'event', text: obj.data })


        }
      } else {
        commit('changeLoggedStatus', false);
        router.push('/login')
        localStorage.removeItem('token');

      }
    },

    //function to get information from the activities editor
    async getEditorActivities({ commit, state },) {
      let ls = JSON.parse(localStorage.getItem('token'))
      if (ls) {
        let data = { token: ls.token }
        let result = await axios({
          method: 'post',
          data: data,
          url: `${state.api}/getEditorActivities`,
          transformRequest: function (obj) {
            var str = [];
            for (var p in obj)
              str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            return str.join("&");
          },
          headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
        })
        let obj = await result.data;
        if (obj.status) {
          commit('setEditorActivities', obj.data);

        }
      } else {
        commit('changeLoggedStatus', false);
        router.push('/login')
        localStorage.removeItem('token');
      }
    },
    async getActivities({ commit, state }, value) {
      let ls = JSON.parse(localStorage.getItem('token'))
      if (ls) {
        let data = { token: ls.token, event_id: value }
        let result = await axios({
          method: 'post',
          data: data,
          url: `${state.api}/getActivities`,
          transformRequest: function (obj) {
            var str = [];
            for (var p in obj)
              str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            return str.join("&");
          },
          headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
        })
        let obj = await result.data;
        if (obj.status) {
          commit('setActivities', obj.data);

        } else {
          if (typeof obj.data == "object") {
            commit('setActivities', obj.data);

          }
        }
      } else {
        commit('changeLoggedStatus', false);
        router.push('/login')
        localStorage.removeItem('token');
      }
    },

    saveActivityID({ commit, state }, data) {
      commit('saveActivityID', data);

    },

    async getActivity({ commit, state }, id) {
      let ls = JSON.parse(localStorage.getItem('token'))
      if (ls) {
        let value = { token: ls.token, id: id }
        let result = await axios({
          method: 'post',
          data: value,
          url: `${state.api}/getActivity`,
          transformRequest: function (obj) {
            var str = [];
            for (var p in obj)
              str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            return str.join("&");
          },
          headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
        })
        let obj = await result.data;
        if (obj.status) {
          commit('setActivity', obj.data);

        }
      } else {
        this.dispatch('changeToolSelected', null)
        commit('changeLoggedStatus', false);
        router.push('/login')
        localStorage.removeItem('token');

      }

    },
    async saveFinishedActivity({ commit, state }, value) {
      commit('setActivityFinished', value);

    },
    async addActivity({ commit, state }, value) {
      this.dispatch('resetError')

      let ls = JSON.parse(localStorage.getItem('token'))
      if (ls) {
        value.token = ls.token
        let formData = new FormData();
        for (var key in value) {
          if (key == 'pictures') {
            if (value.pictures && value.pictures.length > 0) {
              for (var i = 0; i < value.pictures.length; i++) {
                formData.append('pictures[' + i + ']', value.pictures[i]);
              }
            } else {
              formData.append('pictures[0]', value.pictures);
            }
          } else {
            formData.append(key, value[key]);
          }
        }
        let result = await axios({
          method: 'post',
          data: formData,
          url: `${state.api}/addActivity`,
          headers: { 'Content-Type': 'multipart/form-data' }

        })
        let obj = await result.data;
        if (obj.status) {
          if (value.showbudget) {

            await this.dispatch('getActivity', obj.data)
            await this.dispatch('saveActivityID', { id: obj.data, type: 'get' })

            this.dispatch('changeToolSelected', 20)

          } else {
            this.dispatch('changeToolSelected', null)

          }
          this.dispatch('getActivities', value.event_id)
        } else {
          commit('setError', { type: 'activity', text: obj.data })
        }
      } else {
        this.dispatch('changeToolSelected', null)
        commit('changeLoggedStatus', false);
        router.push('/login')
        localStorage.removeItem('token');
      }
    },

    async editActivity({ commit, state }, value) {
      this.dispatch('resetError')
      let ls = JSON.parse(localStorage.getItem('token'))
      if (ls) {
        value.token = ls.token
        let formData = new FormData();
        for (var key in value) {
          if (key == 'pictures') {
            if (value.pictures.length > 0) {
              for (var i = 0; i < value.pictures.length; i++) {
                formData.append('pictures[' + i + ']', value.pictures[i]);
              }
            } else {
              formData.append('pictures[0]', value.pictures);
            }
          } else {
            formData.append(key, value[key]);
          }
        }
        let result = await axios({
          method: 'post',
          data: formData,
          url: `${state.api}/editActivity`,
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        let obj = await result.data;
        if (obj.status) {
          this.dispatch('changeToolSelected', null)
          this.dispatch('getActivities', value.event_id)


        } else {

          commit('setError', { type: 'activity', text: obj.data })

        }
      } else {
        this.dispatch('changeToolSelected', null)
        commit('changeLoggedStatus', false);
        router.push('/login')
        localStorage.removeItem('token');

      }
    },

    async deleteActivity({ commit, state }, value) {
      this.dispatch('resetError')

      let ls = JSON.parse(localStorage.getItem('token'))
      if (ls) {
        value.token = ls.token
        let formData = new FormData();
        for (var key in value) {
          formData.append(key, value[key]);
        }
        let result = await axios({
          method: 'post',
          data: formData,
          url: `${state.api}/deleteActivity`,
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        let obj = await result.data;
        if (obj.status) {
          this.dispatch('getActivities', value.event_id)

        } else {
          commit('setError', { type: 'activity', text: obj.data })
        }
      } else {
        commit('changeLoggedStatus', false);
        router.push('/login')
        localStorage.removeItem('token');
      }
    },

    setEventLanguages({ commit, state }, value) {
      if (typeof value == "string") {
        let replace = value.replace(/\["|"\]/g, '').split(',')
        value = replace
      }
      commit('setEventLanguages', value);
    },
    setEventDays({ commit, state }, value) {
      commit('setEventDays', { date_start: value.date_start, date_end: value.date_end });

    },
    async getUser({ commit, state }) {

      let ls = JSON.parse(localStorage.getItem('token'))
      if (ls) {
        let value = { token: ls.token }
        let result = await axios({
          method: 'post',
          data: value,
          url: `${state.api}/getUser`,
          transformRequest: function (obj) {
            var str = [];
            for (var p in obj)
              str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            return str.join("&");
          },
          headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
        })
        let obj = await result.data;
        if (obj.status) {
          commit('setUser', obj.data);

        }
      } else {
        commit('changeLoggedStatus', false);
        router.push('/login')
        localStorage.removeItem('token');

      }
    },
    async editUser({ commit, state }, value) {
      this.dispatch('resetError')
      let ls = JSON.parse(localStorage.getItem('token'))
      if (ls) {
        value.token = ls.token
        let formData = new FormData();
        for (var key in value) {
          if (key == 'pictures') {
            if (value.pictures && value.pictures.length > 0) {
              for (var i = 0; i < value.pictures.length; i++) {
                formData.append('pictures[' + i + ']', value.pictures[i]);
              }
            } else {
              formData.append('pictures[0]', value.pictures);
            }
          } else {
            formData.append(key, value[key]);
          }
        }
        let result = await axios({
          method: 'post',
          data: formData,
          url: `${state.api}/editUser`,
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        let obj = await result.data;
        if (obj.status) {
          this.dispatch('getUser')
          this.dispatch('getToken')

        } else {
          commit('setError', { type: 'user', text: obj.data })

        }
      } else {
        commit('changeLoggedStatus', false);
        router.push('/login')
        localStorage.removeItem('token');

      }
    },

    async getPrograms({ commit, state }, value) {
      let ls = JSON.parse(localStorage.getItem('token'))
      if (ls) {
        if (state.usertype == 2) {

          let data = { token: ls.token, usertype: state.usertype, event_id: state.event.id, type: value }
          let result = await axios({
            method: 'post',
            data: data,
            url: `${state.api}/getPrograms`,
            transformRequest: function (obj) {
              var str = [];
              for (var p in obj)
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
              return str.join("&");
            },
            headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
          })
          let obj = await result.data;
          if (obj.status) {
            commit('setPrograms', obj.data);

          } else {
            if (typeof obj.data == "object") {
              commit('setPrograms', obj.data);

            }
          }
        } else {
          router.push('/events')

        }
      } else {
        commit('changeLoggedStatus', false);
        router.push('/login')
        localStorage.removeItem('token');
      }
    },
    async getProgram({ commit, state }, id) {
      let ls = JSON.parse(localStorage.getItem('token'))
      if (ls) {
        if (state.usertype == 2) {

          let value = { token: ls.token, id: id, usertype: state.usertype }
          let result = await axios({
            method: 'post',
            data: value,
            url: `${state.api}/getProgram`,
            transformRequest: function (obj) {
              var str = [];
              for (var p in obj)
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
              return str.join("&");
            },
            headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
          })
          let obj = await result.data;
          if (obj.status) {
            commit('setProgram', obj.data);

          }
        } else {
          router.push('/events')

        }
      } else {
        this.dispatch('changeToolSelected', null)
        commit('changeLoggedStatus', false);
        router.push('/login')
        localStorage.removeItem('token');

      }

    },
    saveProgramID({ commit, state }, id) {
      commit('saveProgramID', id);

    },

    async addProgram({ commit, state }, value) {
      this.dispatch('resetError')

      let ls = JSON.parse(localStorage.getItem('token'))
      if (ls) {
        if (state.usertype == 2) {

          value.token = ls.token
          value.usertype = state.usertype
          let formData = new FormData();
          for (var key in value) {
            if (key == 'pictures') {
              if (value.pictures && value.pictures.length > 0) {
                for (var i = 0; i < value.pictures.length; i++) {
                  formData.append('pictures[' + i + ']', value.pictures[i]);
                }
              } else {
                formData.append('pictures[0]', value.pictures);
              }
            } else {
              formData.append(key, value[key]);
            }
          }
          let result = await axios({
            method: 'post',
            data: formData,
            url: `${state.api}/addProgram`,
            headers: { 'Content-Type': 'multipart/form-data' }

          })
          let obj = await result.data;
          if (obj.status) {
            this.dispatch('changeToolSelected', null)
            this.dispatch('getPrograms', 'get')


          } else {
            commit('setError', { type: 'program', text: obj.data })
          }
        } else {
          router.push('/events')

        }
      } else {
        this.dispatch('changeToolSelected', null)
        commit('changeLoggedStatus', false);
        router.push('/login')
        localStorage.removeItem('token');
      }
    },
    async editProgram({ commit, state }, value) {
      this.dispatch('resetError')
      let ls = JSON.parse(localStorage.getItem('token'))
      if (ls) {
        if (state.usertype == 2) {

          value.token = ls.token
          value.usertype = state.usertype
          let formData = new FormData();
          for (var key in value) {
            if (key == 'pictures') {
              if (value.pictures.length > 0) {
                for (var i = 0; i < value.pictures.length; i++) {
                  formData.append('pictures[' + i + ']', value.pictures[i]);
                }
              } else {
                formData.append('pictures[0]', value.pictures);
              }
            } else {
              formData.append(key, value[key]);
            }
          }
          let result = await axios({
            method: 'post',
            data: formData,
            url: `${state.api}/editProgram`,
            headers: { 'Content-Type': 'multipart/form-data' }
          })
          let obj = await result.data;
          if (obj.status) {
            this.dispatch('changeToolSelected', null)
            this.dispatch('getPrograms', 'get')


          } else {
            commit('setError', { type: 'program', text: obj.data })

          }
        } else {
          router.push('/events')

        }
      } else {
        this.dispatch('changeToolSelected', null)
        commit('changeLoggedStatus', false);
        router.push('/login')
        localStorage.removeItem('token');

      }
    },
    async deleteProgram({ commit, state }, value) {
      this.dispatch('resetError')

      let ls = JSON.parse(localStorage.getItem('token'))
      if (ls) {
        if (state.usertype == 2) {

          let formData = new FormData();

          formData.append("id", value);
          formData.append("token", ls.token);
          formData.append("usertype", state.usertype);

          let result = await axios({
            method: 'post',
            data: formData,
            url: `${state.api}/deleteProgram`,
            headers: { 'Content-Type': 'multipart/form-data' }
          })
          let obj = await result.data;
          if (obj.status) {
            this.dispatch('getPrograms', 'get')

          } else {
            commit('setError', { type: 'program', text: obj.data })
          }
        } else {
          router.push('/events')

        }
      } else {
        commit('changeLoggedStatus', false);
        router.push('/login')
        localStorage.removeItem('token');
      }
    },

    async getEquipments({ commit, state }) {
      let ls = JSON.parse(localStorage.getItem('token'))
      if (ls) {
        if (state.usertype == 2) {

          let data = { token: ls.token, usertype: state.usertype }
          let result = await axios({
            method: 'post',
            data: data,
            url: `${state.api}/getEquipments`,
            transformRequest: function (obj) {
              var str = [];
              for (var p in obj)
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
              return str.join("&");
            },
            headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
          })
          let obj = await result.data;
          if (obj.status) {
            commit('setEquipments', obj.data);

          } else {
            if (typeof obj.data == "object") {
              commit('setEquipments', obj.data);

            }
          }
        }
      } else {
        commit('changeLoggedStatus', false);
        const restrictedUrls = ['RecoverPassword', 'Register']
        if (!restrictedUrls.includes(router.currentRoute._value.name)) {
          router.push('/login')
        }
        localStorage.removeItem('token');
      }
    },
    async getEquipment({ commit, state }, id) {
      let ls = JSON.parse(localStorage.getItem('token'))
      if (ls) {
        if (state.usertype == 2) {

          let value = { token: ls.token, id: id, usertype: state.usertype }
          let result = await axios({
            method: 'post',
            data: value,
            url: `${state.api}/getEquipment`,
            transformRequest: function (obj) {
              var str = [];
              for (var p in obj)
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
              return str.join("&");
            },
            headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
          })
          let obj = await result.data;
          if (obj.status) {
            commit('setEquipment', obj.data);

          }
        } else {
          router.push('/events')

        }
      } else {
        this.dispatch('changeToolSelected', null)
        commit('changeLoggedStatus', false);
        router.push('/login')
        localStorage.removeItem('token');

      }

    },
    saveEquipmentID({ commit, state }, id) {
      commit('saveEquipmentID', id);

    },

    async addEquipment({ commit, state }, value) {
      this.dispatch('resetError')

      let ls = JSON.parse(localStorage.getItem('token'))
      if (ls) {
        if (state.usertype == 2) {

          value.token = ls.token
          value.usertype = state.usertype
          let formData = new FormData();
          for (var key in value) {
            if (key == 'pictures') {
              if (value.pictures && value.pictures.length > 0) {
                for (var i = 0; i < value.pictures.length; i++) {
                  formData.append('pictures[' + i + ']', value.pictures[i]);
                }
              } else {
                formData.append('pictures[0]', value.pictures);
              }
            } else {
              formData.append(key, value[key]);
            }
          }
          let result = await axios({
            method: 'post',
            data: formData,
            url: `${state.api}/addEquipment`,
            headers: { 'Content-Type': 'multipart/form-data' }

          })
          let obj = await result.data;
          if (obj.status) {
            this.dispatch('changeToolSelected', null)
            this.dispatch('getEquipments')

          } else {
            commit('setError', { type: 'equipment', text: obj.data })
          }
        } else {
          router.push('/events')

        }
      } else {
        this.dispatch('changeToolSelected', null)
        commit('changeLoggedStatus', false);
        router.push('/login')
        localStorage.removeItem('token');
      }
    },
    async editEquipment({ commit, state }, value) {
      this.dispatch('resetError')
      let ls = JSON.parse(localStorage.getItem('token'))
      if (ls) {
        if (state.usertype == 2) {

          value.token = ls.token
          value.usertype = state.usertype
          let formData = new FormData();
          for (var key in value) {
            if (key == 'pictures') {
              if (value.pictures.length > 0) {
                for (var i = 0; i < value.pictures.length; i++) {
                  formData.append('pictures[' + i + ']', value.pictures[i]);
                }
              } else {
                formData.append('pictures[0]', value.pictures);
              }
            } else {
              formData.append(key, value[key]);
            }
          }
          let result = await axios({
            method: 'post',
            data: formData,
            url: `${state.api}/editEquipment`,
            headers: { 'Content-Type': 'multipart/form-data' }
          })
          let obj = await result.data;
          if (obj.status) {
            this.dispatch('changeToolSelected', null)
            this.dispatch('getEquipments')


          } else {

            commit('setError', { type: 'equipment', text: obj.data })
          }
        } else {
          router.push('/events')

        }
      } else {
        this.dispatch('changeToolSelected', null)
        commit('changeLoggedStatus', false);
        router.push('/login')
        localStorage.removeItem('token');

      }
    },
    async deleteEquipment({ commit, state }, value) {
      this.dispatch('resetError')

      let ls = JSON.parse(localStorage.getItem('token'))
      if (ls) {
        if (state.usertype == 2) {

          let formData = new FormData();

          formData.append("id", value);
          formData.append("token", ls.token);
          formData.append("usertype", state.usertype);

          let result = await axios({
            method: 'post',
            data: formData,
            url: `${state.api}/deleteEquipment`,
            headers: { 'Content-Type': 'multipart/form-data' }
          })
          let obj = await result.data;
          if (obj.status) {
            this.dispatch('getEquipments')

          } else {
            commit('setError', { type: 'equipment', text: obj.data })
          }
        } else {

          router.push('/events')
        }
      } else {
        commit('changeLoggedStatus', false);
        router.push('/login')
        localStorage.removeItem('token');
      }
    },
    async getBudget({ commit, state }) {

      let ls = JSON.parse(localStorage.getItem('token'))
      if (ls) {
        if (state.event.premium == 2) {

          let formData = new FormData();

          formData.append("activity_id", state.activity.id);
          formData.append("token", ls.token);

          let result = await axios({
            method: 'post',
            data: formData,
            url: `${state.api}/getBudget`,
            headers: { 'Content-Type': 'multipart/form-data' }
          })
          let obj = await result.data;
          if (obj.status) {
            commit('setBudget', obj.data);


          } else {
            commit('setError', { type: 'budget', text: obj.data })
          }
        } else {

          router.push('/events')
        }
      } else {
        commit('changeLoggedStatus', false);
        router.push('/login')
        localStorage.removeItem('token');
      }
    },
    async editBudget({ commit, state }, value) {
      this.dispatch('resetError')
      let ls = JSON.parse(localStorage.getItem('token'))
      if (ls) {
        if (state.event.premium == 2) {


          value.token = ls.token
          value.activity_id = state.activity.id

          let formData = new FormData();
          for (var key in value) {
            formData.append(key, value[key]);
          }
          let result = await axios({
            method: 'post',
            data: formData,
            url: `${state.api}/editBudget`,
            headers: { 'Content-Type': 'multipart/form-data' }
          })
          let obj = await result.data;
          if (obj.status) {
            this.dispatch('changeToolSelected', 11)
            // router.push('/events')

          } else {
            commit('setError', { type: 'budget', text: obj.data })
          }
        } else {
          router.push('/events')

        }
      } else {
        this.dispatch('changeToolSelected', null)
        commit('changeLoggedStatus', false);
        router.push('/login')
        localStorage.removeItem('token');

      }
    },
    //function to redirect to payment form
    async savePay({ commit, state }, value) {
      this.dispatch('resetError')

      let ls = JSON.parse(localStorage.getItem('token'))
      if (ls) {
        value.token = ls.token

        let formData = new FormData();
        for (var key in value) {
          formData.append(key, value[key]);
        }
        let result = await axios({
          method: 'post',
          data: formData,
          url: `${state.api}/pay/save`,
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        let obj = await result.data;
        if (obj.status) {
          this.dispatch('changeUserType', value.type)

        } else {

          commit('setError', { type: 'pay', text: obj.data })
        }
      } else {
        this.dispatch('changeToolSelected', null)
        commit('changeLoggedStatus', false);
        router.push('/login')
        localStorage.removeItem('token');

      }
    },
    // function to send contact email
    async sendContactEmail({ commit, state }, value) {
      this.dispatch('resetError')

      let ls = JSON.parse(localStorage.getItem('token'))
      if (ls) {
        value.token = ls.token

        let formData = new FormData();
        for (var key in value) {
          formData.append(key, value[key]);
        }
        let result = await axios({
          method: 'post',
          data: formData,
          url: `${state.api}/sendContact`,
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        let obj = await result.data;
        if (obj.status) {
          router.push('/')

        } else {

          commit('setError', { type: 'email', text: obj.data })
        }
      } else {
        this.dispatch('changeToolSelected', null)
        commit('changeLoggedStatus', false);
        router.push('/login')
        localStorage.removeItem('token');

      }
    }

  },
  modules: {
  }
})
